'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var initState = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var stateKey, persistLog, persist;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        stateKey = _state2.default.settings.startupOptions.state_key;

                        if (typeof stateKey === 'undefined') {
                            stateKey = 'kiwi-state';
                        }

                        persistLog = _Logger2.default.namespace('StatePersistence');
                        persist = new _StatePersistence2.default(stateKey || '', _state2.default, Storage, persistLog);

                        persist.includeBuffers = !!_state2.default.settings.startupOptions.remember_buffers;

                        if (!stateKey) {
                            _context.next = 8;
                            break;
                        }

                        _context.next = 8;
                        return persist.loadStateIfExists();

                    case 8:

                        api.setState(_state2.default);

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function initState() {
        return _ref.apply(this, arguments);
    };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = require('i18next-xhr-backend');

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _vueI18next = require('@panter/vue-i18next');

var _vueI18next2 = _interopRequireDefault(_vueI18next);

var _vClickOutside = require('v-click-outside');

var _vClickOutside2 = _interopRequireDefault(_vClickOutside);

require('whatwg-fetch');

var _available = require('@/res/locales/available.json');

var _available2 = _interopRequireDefault(_available);

var _enUs = require('@/../static/locales/en-us.json');

var _enUs2 = _interopRequireDefault(_enUs);

var _App = require('@/customized-core/App');

var _App2 = _interopRequireDefault(_App);

var _StartupError = require('@/components/StartupError');

var _StartupError2 = _interopRequireDefault(_StartupError);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _ConfigLoader = require('@/libs/ConfigLoader');

var _ConfigLoader2 = _interopRequireDefault(_ConfigLoader);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = require('@/libs/ThemeManager');

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _InputHandler = require('@/libs/InputHandler');

var _InputHandler2 = _interopRequireDefault(_InputHandler);

var _StatePersistence = require('@/libs/StatePersistence');

var _StatePersistence2 = _interopRequireDefault(_StatePersistence);

var _Local = require('@/libs/storage/Local');

var Storage = _interopRequireWildcard(_Local);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _AudioManager = require('@/libs/AudioManager');

var _SoundBleep = require('@/libs/SoundBleep');

var _WindowTitle = require('@/libs/WindowTitle');

var _WindowTitle2 = _interopRequireDefault(_WindowTitle);

var _configTemplates = require('@/res/configTemplates');

require('@/customized-core/utils/TabbedView.vue');

require('@/customized-core/utils/InputText.vue');

require('@/customized-core/utils/IrcInput.vue');

require('@/customized-core/utils/InputPrompt.vue');

require('@/customized-core/utils/InputConfirm.vue');

require('@/thirdparty/');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logLevelMatch = window.location.href.match(/kiwi-loglevel=(\d)/);
if (logLevelMatch && logLevelMatch[1]) {
    _Logger2.default.setLevel(parseInt(logLevelMatch[1], 10));
}

var log = _Logger2.default.namespace('main');

var api = window.kiwi = _GlobalApi2.default.singleton();

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }

    return false;
}

_vue2.default.use(_vClickOutside2.default);

_vue2.default.mixin({
    beforeDestroy: function beforeDestroy() {
        (this.listeningEvents || []).forEach(function (fn) {
            return fn();
        });
    },
    methods: {
        listen: function listen(source, event, fn) {
            this.listeningEvents = this.listeningEvents || [];
            this.listeningEvents.push(function () {
                (source.removeEventListener || source.$off || source.off).call(source, event, fn);
            });
            (source.addEventListener || source.$on || source.on).call(source, event, fn);
        },
        listenOnce: function listenOnce(source, event, fn) {
            this.listeningEvents = this.listeningEvents || [];
            this.listeningEvents.push(function () {
                (source.removeEventListener || source.$off || source.off).call(source, event, fn);
            });

            if (source.addEventListener) {
                var onceFn = function onceFn() {
                    source.removeEventListener(event, onceFn);
                    fn.apply(undefined, arguments);
                };

                source.addEventListener(event, onceFn);
            } else {
                (source.$once || source.once).call(source, event, fn);
            }
        }
    }
});

_vue2.default.mixin({
    computed: {
        $state: function $state() {
            return _state2.default;
        }
    }
});

_vue2.default.directive('rawElement', {
    bind: function bind(el, binding) {
        if (binding.value.nodeName) {
            el.appendChild(binding.value);
        } else if (binding.value.el) {
            var rawEl = binding.value.el;
            el.appendChild(rawEl);

            if (binding.value.data) {
                (0, _keys2.default)(binding.value.data).forEach(function (key) {
                    rawEl.dataset[key] = binding.value.data[key];
                });
            }

            if (binding.value.props) {
                (0, _keys2.default)(binding.value.props).forEach(function (key) {
                    rawEl[key] = binding.value.props[key];
                });
            }
        }
    }
});

_vue2.default.directive('focus', {
    inserted: function inserted(el) {
        if (el.tagName === 'INPUT') {
            el.focus();
            return;
        }

        var input = el.getElementsByTagName('input')[0];
        if (input) {
            input.focus();
        }
    }
});

loadApp();

function loadApp() {
    var configFile = 'static/config.json';
    var configObj = null;

    if (getQueryVariable('config')) {
        configFile = 'static/config_' + getQueryVariable('config') + '.json';
    } else if (typeof window.kiwiConfig === 'function') {
        try {
            configObj = window.kiwiConfig();
        } catch (err) {
            log.error('Config file: ' + err.stack);
            showError();
        }
    } else if (document.querySelector('meta[name="kiwiconfig"]')) {
        configFile = document.querySelector('meta[name="kiwiconfig"]').content;
    } else if (document.querySelector('script[name="kiwiconfig"]')) {
        var configContents = document.querySelector('script[name="kiwiconfig"]').innerHTML;

        try {
            configObj = JSON.parse(configContents);
        } catch (parseErr) {
            log.error('Config file: ' + parseErr.stack);
            showError();
        }
    }

    var configLoader = new _ConfigLoader2.default();
    configLoader.addValueReplacement('hostname', window.location.hostname).addValueReplacement('host', window.location.hostname).addValueReplacement('host', window.location.host).addValueReplacement('port', window.location.port || 80).addValueReplacement('hash', (window.location.hash || '').substr(1)).addValueReplacement('query', (window.location.search || '').substr(1)).addValueReplacement('referrer', window.document.referrer);

    (configObj ? configLoader.loadFromObj(configObj) : configLoader.loadFromUrl(configFile)).then(applyConfig).then(initState).then(initInputCommands).then(initLocales).then(initThemes).then(loadPlugins).then(initSound).then(startApp).catch(showError);
}

function applyConfig(config) {
    Misc.dedotObject(config);

    if (_configTemplates.configTemplates[config.template]) {
        applyConfigObj(_configTemplates.configTemplates[config.template], _state2.default.settings);
    }
    applyConfigObj(config, _state2.default.settings);
}

function applyConfigObj(obj, target) {
    _lodash2.default.each(obj, function (val, key) {
        if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
            if ((0, _typeof3.default)(target[key]) !== 'object') {
                var newVal = _lodash2.default.isArray(val) ? [] : {};

                _vue2.default.set(target, key, newVal);
            }
            applyConfigObj(val, target[key]);
        } else {
            _vue2.default.set(target, key, val);
        }
    });
}

function loadPlugins() {
    return new _promise2.default(function (resolve, reject) {
        var plugins = _state2.default.settings.plugins || [];
        var pluginIdx = -1;

        loadNextScript();

        function loadNextScript(sSrc, fOnload) {
            var plugin = plugins[++pluginIdx];

            if (!plugin) {
                resolve();
                return;
            }

            if (plugin.url.indexOf('.js') > -1) {
                var scr = document.createElement('script');
                scr.onerror = function () {
                    log.error('Error loading plugin \'' + plugin.name + '\' from \'' + plugin.url + '\'');
                    loadNextScript();
                };
                scr.onload = function () {
                    loadNextScript();
                };

                document.body.appendChild(scr);
                scr.src = plugin.url;
            } else {
                fetch(plugin.url).then(function (response) {
                    return response.text();
                }).then(function (pluginRaw) {
                    var el = document.createElement('div');
                    el.id = 'kiwi_plugin_' + plugin.name.replace(/[ "']/g, '');
                    el.style.display = 'none';
                    el.innerHTML = pluginRaw;

                    var scripts = [].concat((0, _toConsumableArray3.default)(el.querySelectorAll('script')));

                    scripts.forEach(function (limitedScr) {
                        limitedScr.parentElement.removeChild(limitedScr);
                        var scr = document.createElement('script');
                        scr.text = limitedScr.text;
                        el.appendChild(scr);
                    });

                    document.body.appendChild(el);
                    loadNextScript();
                }).catch(function () {
                    log.error('Error loading plugin \'' + plugin.name + '\' from \'' + plugin.url + '\'');
                    loadNextScript();
                });
            }
        }
    });
}

function initLocales() {
    _vue2.default.use(_vueI18next2.default);

    api.i18n = _i18next2.default;

    _i18next2.default.use(_i18nextXhrBackend2.default);
    _i18next2.default.init({
        whitelist: _available2.default.locales,
        fallbackLng: 'en-us',
        lowerCaseLng: true,
        backend: {
            loadPath: 'static/locales/{{lng}}.json',

            crossDomain: false,

            withCredentials: false
        },
        interpolation: {
            escapeValue: false
        }
    });

    _i18next2.default.addResourceBundle('en-us', 'translation', _enUs2.default);

    _vue2.default.mixin({
        computed: {
            $t: function $t() {
                var _this = this;

                return function (key, options) {
                    var val = _this.$i18n.i18next.t(key, options, _this.$i18n.i18nLoadedAt);
                    if (!val) {
                        var opts = options || {};
                        opts.lng = 'en-us';
                        val = _this.$i18n.i18next.t(key, opts, _this.$i18n.i18nLoadedAt);
                    }
                    return val;
                };
            }
        }
    });

    var setDefaultLanguage = function setDefaultLanguage() {
        var defaultLang = _state2.default.setting('language');
        var preferredLangs = _lodash2.default.clone(window.navigator && window.navigator.languages) || [];

        if (defaultLang) {
            preferredLangs.unshift(defaultLang);
        }

        _i18next2.default.changeLanguage('en-us');

        for (var idx = 0; idx < preferredLangs.length; idx++) {
            var lang = preferredLangs[idx];

            if (lang.length === 2) {
                preferredLangs.splice(idx + 1, 0, lang + '-' + lang);
            }

            if (_lodash2.default.includes(_available2.default.locales, lang.toLowerCase())) {
                _i18next2.default.changeLanguage(lang, function (err, t) {
                    if (err) {
                        _i18next2.default.changeLanguage('en-us');
                    }
                });
                break;
            }
        }
    };
    setDefaultLanguage();

    _state2.default.$watch('user_settings.language', function (lang) {
        if (!lang && !_state2.default.setting('language')) {
            setDefaultLanguage();
        } else {
            _i18next2.default.changeLanguage(lang || _state2.default.setting('language') || 'en-us');
        }
    });
}

function initThemes() {
    var themeMgr = _ThemeManager2.default.instance(_state2.default);
    api.setThemeManager(themeMgr);

    var argTheme = getQueryVariable('theme');
    if (argTheme) {
        themeMgr.setTheme(argTheme);
    }
}

function initSound() {
    var sound = new _SoundBleep.SoundBleep();
    var bleep = new _AudioManager.AudioManager(sound);

    bleep.listen(_state2.default);
    bleep.watchForMessages(_state2.default);
}

function initInputCommands() {
    new _InputHandler2.default(_state2.default);
}

function startApp() {
    new _WindowTitle2.default(_state2.default);

    api.emit('init');

    new _vue2.default({
        el: '#app',
        render: function render(h) {
            return h(_App2.default);
        },
        i18n: new _vueI18next2.default(_i18next2.default)
    });

    api.emit('ready');
}

function showError(err) {
    if (err) {
        log.error('Error starting Kiwi IRC:', err);
    } else {
        log.error('Unknown error starting Kiwi IRC');
    }

    new _vue2.default({
        el: '#app',
        render: function render(h) {
            return h(_StartupError2.default, { props: { error: err } });
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = NHnr
// module chunks = 1